import { Box, Typography } from "@mui/material";
import React, { useRef } from "react";
import { ExpandScriptIcon } from "../../../../Custom-imeges/VideoSuite/ExpandScriptIcon";
import SignalRService from "../../../one-query/services/SignalRService";
import { RandomImageIcon } from "../../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/RandomImageIcon";
import { ImprovePromptBtn } from "../../../ImageSuite/Components/Shared/ImprovePromptBtn";

interface ScriptCardProps {
  handleShowScriptModal: () => void;
  setInputValue: (value: string) => void;
  inputValue: string;
  handleGenerateRandomScript: (connectionId: string) => void;
  handelImprovePrompt?: () => void;
  isPromptImproving?:boolean;
}

export const ScriptCard = ({
  handleShowScriptModal,
  setInputValue,
  inputValue,
  handleGenerateRandomScript,
  handelImprovePrompt,
  isPromptImproving
}: ScriptCardProps) => {
  const scriptInputRef = useRef<HTMLTextAreaElement | null>(null);

  const handleFocusOnScriptInput = async () => {
    const connectionId = await SignalRService.getInstance().getConnectionId();
    if (scriptInputRef.current) {
      setInputValue("");
      handleGenerateRandomScript(connectionId);
      scriptInputRef.current.focus();
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setInputValue(event.target.value);
  };

  return (
    <Box className="script-card">
      <Typography className="script-card-title">Script</Typography>
      <Box className="script-container">
        <Box className="script-input">
          <textarea
            value={inputValue}
            onChange={handleInputChange}
            ref={scriptInputRef}
            className="custom-textarea-suite"
            placeholder="Type script.."
            rows={3}
          />
        </Box>
        <Box className="script-types">
          <Box className="script-type" onClick={handleFocusOnScriptInput}>
            <RandomImageIcon className="inspire-icon" />
            <Typography>Inspire Me</Typography>
          </Box>
          <Box className="improve-script-box">
            <ImprovePromptBtn
              handelImprovePrompt={handelImprovePrompt!}
              isDisabled={isPromptImproving || inputValue.length === 0}
              inputValue={inputValue}
            />
          </Box>
          <Box className="expand-script" onClick={handleShowScriptModal}>
            <ExpandScriptIcon />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
